import React, { useState } from "react";
import axios from "axios";

function LiveRoomInfo() {
  const [uid, setUid] = useState(0);
  const [liveRoom, setLiveRoom] = useState();
  const [roomName, setRoomName] = useState("");
  const [updatingName, setUpdatingName] = useState(false);
  const [thumbnail, setThumbnail] = useState("");
  const [updatingThumbnail, setUpdatingThumbnail] = useState(false);

  const [loading, setLoading] = useState(null);

  async function getLiveRoom() {

    let id = window.localStorage.getItem("userId");

    try {
        
      setLoading(true);
      setLiveRoom(null);
      setRoomName("");
      setThumbnail("");

      await axios.get(`${global.config.apiDomain}/rest/live-room/get-live-room`, {
        params: { uid: uid, id: id}
      })
      .then(res => {
        if (res.data.status === "OK") {
          setLiveRoom(res.data.data.liveRoom);
          setRoomName(res.data.data.liveRoom.name || "");
          setThumbnail(res.data.data.liveRoom.thumbnail || "");
        } else {
          setLiveRoom(null);
          alert(res.data.message || "Không tìm thấy phòng.");
        }      
      })
      .catch(error => {
          console.error("Error:", error);
          alert("Không thể tải thông tin phòng.");
      });
      setLoading(false);
        
      } catch (error) {
        
      }

  }

  async function saveRoomName() {
    const name = roomName.trim();
    if (!liveRoom || updatingName || name.length < 5 || name.length > 20) {
      alert("Tên phòng phải dài từ 5 đến 20 ký tự.");
      return;
    }

    setUpdatingName(true);
    try {
      const response = await axios.post(global.config.apiDomain + "/mc-live-room/web/live-rooms/name", {
        roomId: liveRoom.id,
        name
      });
      if (response.data.status !== "OK") throw new Error(response.data.message || "Đổi tên phòng thất bại.");
      setLiveRoom({ ...liveRoom, name: response.data.data.name });
      setRoomName(response.data.data.name);
      alert("Đã đổi tên phòng.");
    } catch (error) {
      alert(error.response?.data?.message || error.message || "Đổi tên phòng thất bại.");
    } finally {
      setUpdatingName(false);
    }
  }

  async function uploadThumbnail(event) {
    const file = event.target.files[0];
    event.target.value = "";
    if (!file || !liveRoom || updatingThumbnail) return;
    const extensions = { "image/jpeg": "jpg", "image/png": "png", "image/webp": "webp" };
    const extension = extensions[file.type];
    if (!extension || file.size > 5 * 1024 * 1024) {
      alert("Chọn ảnh JPG, PNG hoặc WebP tối đa 5 MB.");
      return;
    }

    const random = new Uint32Array(4);
    window.crypto.getRandomValues(random);
    const objectKey = Array.from(random, value => value.toString(16).padStart(8, "0")).join("") + "." + extension;
    const bucketName = "ikara-data/images/live-rooms/" + liveRoom.id;
    const expectedUrl = "https://data4.ikara.co/data/minio/" + bucketName + "/" + objectKey;
    const form = new FormData();
    form.append("file", file);
    form.append("bucketName", bucketName);
    form.append("objectKey", objectKey);
    form.append("contentType", file.type);

    setUpdatingThumbnail(true);
    try {
      const response = await axios.post(global.config.apiDomain + "/web.UploadFile", form, { responseType: "text" });
      if (typeof response.data !== "string" || response.data.trim() !== expectedUrl) {
        throw new Error("Upload ảnh thất bại.");
      }
      setThumbnail(expectedUrl);
    } catch (error) {
      alert(error.response?.data?.message || error.message || "Upload ảnh thất bại.");
    } finally {
      setUpdatingThumbnail(false);
    }
  }

  async function saveThumbnail() {
    const imageUrl = thumbnail.trim();
    if (!liveRoom || updatingThumbnail || !/^https:\/\/\S+$/.test(imageUrl)) {
      alert("Nhập URL ảnh HTTPS hợp lệ hoặc upload ảnh trước khi lưu.");
      return;
    }

    setUpdatingThumbnail(true);
    try {
      const response = await axios.post(global.config.apiDomain + "/mc-live-room/web/live-rooms/thumbnail", {
        roomId: liveRoom.id,
        thumbnail: imageUrl
      });
      if (response.data.status !== "OK") throw new Error(response.data.message || "Cập nhật ảnh thất bại.");
      setLiveRoom({ ...liveRoom, thumbnail: response.data.data.thumbnail });
      setThumbnail(response.data.data.thumbnail);
      alert("Đã cập nhật ảnh phòng.");
    } catch (error) {
      alert(error.response?.data?.message || error.message || "Cập nhật ảnh thất bại.");
    } finally {
      setUpdatingThumbnail(false);
    }
  }

  async function setTalkRoom() {

    let id = window.localStorage.getItem("userId");

    try {
    
      setLoading(true);
  
      await axios.put(`${global.config.apiDomain}/rest/live-room/set-talk-room`, null, {
        params: { uid: uid, id: id }
      })
        .then(res => {
          if (res.data.status === "OK") {
            alert("Thành công");
            getLiveRoom();
          } else {
            alert("Có lỗi", res.data.message);
          } 
        })
        .catch(error => {
          console.error("Error:", error);
        });
      setLoading(false);
      
    } catch (error) {
      
    }


  }

  return (
    <>
      <div
        className="container"
        style={{
          marginTop: "100px",
          marginBottom: "100px",
        }}
      >
        <h1 className="text-center">Live Room</h1>
        <div className="filter-container">
          <label htmlFor="time-search" style={{ paddingRight: "50px" }}>
            Nhập Uid phòng cần kiểm tra
          </label>
          <input
            id="time-search-start"
            type="number"
            onChange={(e) => setUid(e.target.value)}
            placeholder="Nhập uid phòng"
          />
          <br />
          <button className="btn" onClick={getLiveRoom}>
            Tìm Kiếm
          </button>
        </div>
        {
          loading === null ? (
            <h1>Lựa chọn Uid phòng để tra cứu data</h1>
          ) : loading === true ? (
            <h1>Đang tải dữ liệu...</h1>
          ) : (
            <table
              className="table table-bordered table-hover"
              style={{ marginTop: "20px" }}
            >
              <tbody>
                {liveRoom ? (
                  <>
                    <tr>
                      <th>Id</th>
                      <td>{liveRoom.id}</td>
                    </tr>
                    <tr>
                      <th>Uid</th>
                      <td>{liveRoom.uid}</td>
                    </tr>
                    <tr>
                      <th>Tên phòng</th>
                      <td>
                        <input type="text" value={roomName} onChange={event => setRoomName(event.target.value)} maxLength={20} style={{ width: "100%", marginBottom: 12 }} disabled={updatingName} />
                        <button onClick={saveRoomName} disabled={updatingName || !roomName.trim()}>
                          {updatingName ? "Đang lưu..." : "Lưu tên phòng"}
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th>Ảnh phòng</th>
                      <td>
                        {liveRoom.thumbnail && <img src={liveRoom.thumbnail} alt="Ảnh phòng hiện tại" style={{ width: 100, height: 100, objectFit: "cover", display: "block", marginBottom: 12 }} />}
                        <input type="file" accept="image/jpeg,image/png,image/webp" onChange={uploadThumbnail} disabled={updatingThumbnail} />
                        <input type="url" value={thumbnail} onChange={event => setThumbnail(event.target.value)} placeholder="URL ảnh HTTPS" style={{ display: "block", width: "100%", margin: "12px 0" }} disabled={updatingThumbnail} />
                        {thumbnail && thumbnail !== liveRoom.thumbnail && <img src={thumbnail} alt="Ảnh phòng mới" style={{ width: 100, height: 100, objectFit: "cover", display: "block", marginBottom: 12 }} />}
                        <button onClick={saveThumbnail} disabled={updatingThumbnail || !thumbnail.trim() || thumbnail.trim() === liveRoom.thumbnail}>
                          {updatingThumbnail ? "Đang xử lý..." : "Lưu ảnh phòng"}
                        </button>
                      </td>
                    </tr>
                    <tr>
                      <th>Kind</th>
                      <td>{liveRoom.kind}</td>
                    </tr>
                    <tr>
                      <th>Who Can Join</th>
                      <td>{liveRoom.whoCanJoin}</td>
                    </tr>
                    <tr>
                      <th>Who Can Sing</th>
                      <td>{liveRoom.whoCanSing}</td>
                    </tr>
                    <tr>
                      <th>Background Type</th>
                      <td>{liveRoom.backgroundType}</td>
                    </tr>
                    <tr>
                      <th>Owner FbId</th>
                      <td>{liveRoom.ownerFbId}</td>
                    </tr>
                    {liveRoom.kind && liveRoom.kind !== "TALK" && (
                      <tr>
                        <th>Tool</th>
                        <td>
                          <button onClick={() => setTalkRoom()}>Đổi room Type to TALK</button>
                        </td>
                      </tr>
                    )}
                  </>
                ) : (
                  <tr>
                    <td colSpan={2}>Không có dữ liệu</td>
                  </tr>
                )}
              </tbody>
            </table>
          )
        }
      </div>
    </>
  );
  
}

export default LiveRoomInfo;
